import Swiper from 'swiper'
import { Navigation, Pagination, Scrollbar, Thumbs, EffectFade, Autoplay } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

export const initSwiper = () => {
	let config
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')

		switch (type) {
			case 'banner':
				config = {
					loop: true,
					speed: 1000,
					effect: 'fade',
					slidesPerView: 1,
					autoplay: true,
					modules: [EffectFade, Autoplay]
				}
				break
			case 'homepage-gallery':
				config = {
					modules: [Navigation, Pagination],
					speed: 1000,
					loop: false,
					initialSlide: 1,
					spaceBetween: 14,
					slidesPerView: 1.05,
					centeredSlides: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					breakpoints: {
						650: {
							spaceBetween: 24
						},
						1024: {
							spaceBetween: 24,
							slidesPerView: 1.2
						}
					}
				}
				break
			case 'about':
				config = {
					modules: [Scrollbar],
					spaceBetween: 14,
					slidesPerView: 1.1,
					scrollbar: {
						el: '.swiper-scrollbar'
					},
					breakpoints: {
						650: {
							spaceBetween: 24,
							slidesPerView: 2.1
						},
						1024: {
							slidesPerView: 3
						}
					}
				}
				break
			case 'events':
				config = {
					modules: [Scrollbar],
					spaceBetween: 14,
					slidesPerView: 1.1,
					scrollbar: {
						el: '.swiper-scrollbar'
					},
					breakpoints: {
						650: {
							spaceBetween: 24,
							slidesPerView: 2.5
						},
						1024: {
							spaceBetween: 24,
							slidesPerView: 4
						}
					}
				}
				break
		}

		const swiper = new Swiper(slider, { ...config })
	})
}

export default () => {}
